import { render, staticRenderFns } from "./BigCrunchModal.vue?vue&type=template&id=26523be9&"
import script from "./BigCrunchModal.vue?vue&type=script&lang=js&"
export * from "./BigCrunchModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports